// #642 — THE app: one live, time-ordered running order for ONE ring.
//
// Read-only by construction. The announcer never writes a score, never changes a
// status, never touches FVD — which is what keeps this screen small.
//
// Freshness, per docs/score/announcer.md:
//   - ride STATUSES change constantly during a class -> poll every 5s
//     (useRideStatuses; it already pauses on a hidden tab and refreshes on
//     return, so nothing here needs a visibility listener of its own).
//   - rides / breaks / classes change on a scratch, a schedule reorder, or a
//     re-ingest -> refetched on the SAME 5s beat (#692 — a class
//     reorder/scratch/moved break must show up on the very next poll, and an
//     FVD change must be visible within 5s). #2190 — no local cache anymore;
//     a failed refetch just leaves whatever's already on screen alone.
//     people/horses stay on their own one-shot fetch (useRoster.js) —
//     org-wide roster data that isn't part of the running order.
//
// #692 polling cost, one ring/terminal, one show day (all single-query GSI
// reads, no per-class fan-out — #637's showId/ring filter on GET /ride):
//   GET /ride?showId&ring      (ridesByShow GSI)    -> 720/hr
//   GET /break?showId&ring     (breaksByShow GSI)   -> 720/hr
//   GET /class?showId                               -> 720/hr
//   POST /rides/status (batch)                       -> 720/hr
//   ~2,880 reads/hr/terminal. Cheap: each is one indexed query, not a scan,
//   and a full 8-hour show day is well under 25k reads per terminal even with
//   several terminals running at once.
export const STATUS_POLL_MS = 5000;
export const ENTITY_POLL_MS = 5000;
// #645 — how long the screen can go without a successful status refresh
// before it stops calling itself "live", even while `online` is still true.
// A single missed poll (a blip) shouldn't flash the banner; four missed polls
// (STATUS_POLL_MS * 4) means something's actually wrong upstream.
export const STALE_THRESHOLD_MS = STATUS_POLL_MS * 4;
// How often the banner's own clock re-checks staleness / re-renders its
// "HH:MM" text. Independent of the entity/status polls — this never touches
// the network, it just re-evaluates wall-clock math.
export const CLOCK_TICK_MS = 10000;
// #691 — the sticky header's live clock + countdown want a proper ticking
// feel, so they get their own faster tick, separate from the freshness
// banner's coarser one above. Still fetches nothing — pure wall-clock math.
export const LIVE_TICK_MS = 1000;
